<template>
  <div class="page-container">
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/01.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/02.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/03.jpg" />
      <div class="rule" @click="$refs.rulesRef.open()"></div>
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/04.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/05.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/06.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/07.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/08.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/09.jpg" />
      <div class="detail-01" @click="partakeDetail(0)"></div>
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/10.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/11.jpg" />
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/12.jpg" />
      <div class="detail-02">
        <div class="item" @click="partakeDetail(1)"></div>
        <div class="item" @click="showPopup=true"></div>
      </div>
    </div>
    <div class="container">
      <img class="img" src="@/static/images/activityCenter/202403/02/13.png" />
    </div>

    <van-popup v-model="showPopup" position="bottom" round :style="{ height: '60%' }">
      <div class="popup-container">
        <div class="list-box">
          <div class="item">
            <span>国联人寿鑫运如意两全保险</span>
          </div>
          <div class="item">
            <span>中宏宏福相伴互联网终身寿险</span>
          </div>
          <div class="item">
            <span>中荷互联网岁岁享护理保险</span>
          </div>
          <div class="item">
            <span>海保人寿金管家(稳赢版)终身寿险(万能型)</span>
          </div>
          <div class="item">
            <span>恒安标准恒爱年年尊享版终身年金保险(分红型)</span>
          </div>
          <div class="item">
            <span>恒安标准传世臻耀终身寿险(分红型)</span>
          </div>
          <div class="item">
            <span>复星联合福星高照(焕新版)护理保险</span>
          </div>
          <div class="item">
            <span>海港启明星龙腾版终身寿险</span>
          </div>
          <div class="item">
            <span>横琴传世金彩(鑫享版) 增额终身寿险(分红型)</span>
          </div>
          <div class="item">
            <span>招商信诺养老年金保险C款(分红型)</span>
          </div>
          <div class="item">
            <span>横琴鼎世金彩增额终身寿险</span>
          </div>
          <div class="item">
            <span>珠江益寿年年终身养老年金保险</span>
          </div>
          <div class="item">
            <span>长城八达岭赤免版年金保险 (2024)</span>
          </div>
          <div class="item">
            <span>长城人寿山海关(龙腾版)终身寿险</span>
          </div>
          <div class="item">
            <span>国联人寿平安如意两全保险B款</span>
          </div>
          <div class="item">
            <span>大家养老福满满2号养老年金保险</span>
          </div>
          <div class="item">
            <span>复星联合康爱一生护理保险(荣耀版)</span>
          </div>
          <div class="item">
            <span>招商仁和锦麟侠1号终身寿险</span>
          </div>
          <div class="item">
            <span>横琴传世金彩(稳赢版)增额终身寿险</span>
          </div>
          <div class="item">
            <span>昆仑健康岁享金生终身护理保险</span>
          </div>
          <div class="item">
            <span>复星保德信星海赢家(龙腾版) 养老年金保险</span>
          </div>
          <div class="item">
            <span>弘康悦享长盈终身寿险(投资连结型)</span>
          </div>
          <div class="item">
            <span>珠江人寿永鑫年年年金保险</span>
          </div>
          <div class="item">
            <span>珠江人寿增寿年年终身寿险</span>
          </div>
          <div class="item">
            <span>阳光人寿阳光升C款增额寿险</span>
          </div>
          <div class="item">
            <span>弘康悦享长盈终身寿险(投资连结型)</span>
          </div>
          <div class="item">
            <span>瑞华乐享一生终身护理保险(2.0版)</span>
          </div>
          <div class="item">
            <span>海港人寿启明星臻享版终身寿险</span>
          </div>
          <div class="item">
            <span>昆仑健康乐享年年终身护理保险</span>
          </div>
          <div class="item">
            <span>长城山海关永乐版终身寿险 (2023)</span>
          </div>
          <div class="item">
            <span>国联人寿鑫运年年终身寿险</span>
          </div>
          <div class="item">
            <span>太保智相守终身护理保险</span>
          </div>
          <div class="item">
            <span>幸福人寿幸福乐享终身寿险</span>
          </div>
          <div class="item">
            <span>信泰如意致享养老年金保险【60岁以下-湖北北京广东(含深圳)】</span>
          </div>
          <div class="item">
            <span>复星联合康爱一生护理保险(荣耀版)【支持双录】</span>
          </div>
          <div class="item">
            <span>爱心人寿守护神终身寿险(臻享版)</span>
          </div>
          <div class="item">
            <span>复星联合光辉岁月护理保险</span>
          </div>
          <div class="item">
            <span>大家养老大盈之家2.0养老年金保险</span>
          </div>
          <div class="item">
            <span>信泰如意致享养老年金保险【支持双录-青岛河北江西江苏湖北北京广东(含深圳)】</span>
          </div>
          <div class="item">
            <span>中意臻享一生(鑫玺版)终身寿险(分红型)</span>
          </div>
          <div class="item">
            <span>信美相互传家有道(龙腾版)终身寿险</span>
          </div>
          <div class="item">
            <span>信美相互挚信一生龙腾A款终身养老年金保险</span>
          </div>
          <div class="item">
            <span>信美相互挚信一生龙腾B 款终身养老年金保险</span>
          </div>
          <div style="height:50px;"></div>
        </div>
      </div>
    </van-popup>

    <!-- 规则 -->
    <billing-rules ref="rulesRef"></billing-rules>
  </div>
</template>

<script>
import config from '@/api/common'; //公共变量
import billingRules from './components/billingRules';

export default {
  components: {
    billingRules
  },

  data() {
    return {
      showPopup: false,
      list: [],
      productionIds: ['1763043121374773249', '1782669229218172930'],
      localIds: ['1763121347519553538', '1744607342545518594']
    };
  },

  created() {
    this.getList();
    console.log(navigator.userAgent)
  },

  methods: {
    getList() {
      this.$http({
        type: 'GET',
        url: '/app/merchantActivity/detailList',
        data: {
          idList: config.env == 1 ? this.productionIds.join(',') : this.localIds.join(',')
        }
      }).then(res => {
        this.list = res.data;
      });
    },

    partakeDetail(index) {
      this.$router.push({
        path: '/apps/partakeList',
        query: {
          id: config.env == 1 ? this.productionIds[index] : this.localIds[index],
          type: this.list[index].type,
          calFactor: this.list[index].calFactor,
          productType: this.list[index].productType,
          mode: this.list[index].mode,
          status: this.list[index].status,
          conditionalIndicator: this.list[index].conditionalIndicator
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  .container {
    position: relative;
    .img {
      width: 750px;
      display: block;
    }
    .rule {
      position: absolute;
      right: 0;
      top: 0;
      width: 50px;
      height: 65px;
    }
    .detail-01 {
      position: absolute;
      bottom: 92px;
      left: 50%;
      margin-left: -225px;
      width: 450px;
      height: 90px;
      border-radius: 45px;
    }
    .detail-02 {
      position: absolute;
      bottom: 30px;
      width: 550px;
      height: 50px;
      left: 50%;
      margin-left: -270px;
      display: flex;
      justify-content: space-between;
      .item {
        width: 260px;
        height: 50px;
        border-radius: 25px;
      }
    }
  }

  .popup-container {
    position: relative;
    background: url('../../../../../static/images/activityCenter/202403/popup_bg.png') no-repeat;
    background-size: 100% 100%;
    padding: 118px 30px 41px 20px;    
    .list-box {
      height: 815px;
      overflow-y: auto;
      .item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 23px 0px;
        background: rgba(255, 255, 255, 0.6);
        border-radius: 8px;
        margin-bottom: 10px;
        margin-left: 10px;
        span {
          padding: 0 0;
          margin: 0;
          font-size: 28px;
          color: #621d08;
          font-weight: bold;
        }
      }
    }
  }
  .rule-popup {
    background-color: transparent;
    /deep/.van-popup__close-icon {
      top: 52px;
    }
  }
}
</style>
